import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 注释
import { fetchCreate, fetchUpdate } from '@/api/PMS/baseInformation/customer';
import { fetchListByType, fetchLinkageTree } from '@/api/PMS/dic/dic';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        areaGroupId: [{
          required: true,
          message: '请选择小区名称',
          trigger: 'blur'
        }],
        customerType: [{
          required: true,
          message: '请选择客户类别',
          trigger: 'blur'
        }],
        customerName: [{
          required: true,
          message: '请输入客户名称',
          trigger: 'blur'
        }],
        userSex: [{
          required: true,
          message: '请选择客户性别',
          trigger: 'change'
        }],
        userCardType: [{
          required: true,
          message: '请选择证件类型',
          trigger: 'change'
        }],
        userCardSerno: [{
          required: true,
          message: '请输入证件号码',
          trigger: 'blur'
        }],
        userPhoneOne: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        companyAccountName: [{
          required: true,
          message: '请输入公司开户名称',
          trigger: 'blur'
        }],
        companyBankAccount: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }],
        companyCreditCode: [{
          required: true,
          message: '请输入统一社会信用代码',
          trigger: 'blur'
        }],
        companyLegal: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }],
        legalPhoneOne: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        companyPhoneFax: [{
          required: true,
          message: '请输入单位传真',
          trigger: 'blur'
        }],
        companyPhone: [{
          required: true,
          message: '请输入公司电话',
          trigger: 'blur'
        }],
        postName: [{
          required: true,
          message: '请输入职业名称',
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      linkageTree: {
        label: 'dicName',
        value: 'dicValue',
        children: 'dicList'
      },
      originUpIdList: [],
      originNativeList: [],
      options: [],
      nativeOptions: [],
      isDisabled: false,
      showPerson: true,
      childData: {
        upIdList: [],
        nativeList: []
      },
      typeOption: [],
      sexOption: [],
      documentOption: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.childData = {
        areaGroupId: this.keyValue,
        customerType: 1
      };
      this.isDisabled = false;
      this.typeOption = [];
      this.sexOption = [];
      this.documentOption = [];
      this.loadSexOptions();
      this.loadDocumentOptions();
      this.loadTypeOptions();
      this.loadMenuTree();
      this.loadLinkageTree();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handTenantCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              }
            });
          } else {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code === 200) {
                _this2.$emit('handTenantCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handTenantCancle', false);
    },
    loadSexOptions: function loadSexOptions() {
      var _this3 = this;

      fetchListByType('user_sex').then(function (r) {
        _this3.sexOption = r.data.data;
        _this3.sexOption = _this3.sexOption.reverse();
      });
    },
    loadMenuTree: function loadMenuTree() {
      var _this4 = this;

      var treeQuery = {
        flag: 1
      };
      fetchTreeList(treeQuery).then(function (res) {
        if (res.data.data) {
          _this4.options = res.data.data.map(function (item) {
            return {
              dicName: item.name,
              dicValue: item.id
            };
          });
        }
      });
    },
    resetCustomerType: function resetCustomerType() {
      this.$set(this.childData, 'customerName', '');
      this.$set(this.childData, 'companyCreditCode', '');
      this.$set(this.childData, 'userPhoneOne', '');
      this.$set(this.childData, 'legalPhoneOne', '');
      this.$set(this.childData, 'userCardType', '');
      this.$set(this.childData, 'userCardSerno', '');
      this.$set(this.childData, 'postName', '');
    },
    loadLinkageTree: function loadLinkageTree() {
      var _this5 = this;

      fetchLinkageTree().then(function (response) {
        _this5.nativeOptions = response.data.data;
      });
    },
    loadTypeOptions: function loadTypeOptions() {
      var _this6 = this;

      fetchListByType('customer_type').then(function (r) {
        _this6.typeOption = r.data.data;
      });
    },
    loadDocumentOptions: function loadDocumentOptions() {
      var _this7 = this;

      fetchListByType('user_card_type').then(function (r) {
        _this7.documentOption = r.data.data;
      });
    },
    changeTypeValue: function changeTypeValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.customerType === val;
      });
      this.childData.customerType = obj.dicName;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.userCardType === val;
      });
      this.childData.userCardType = obj.dicName;
    }
  }
};